import React, { Fragment } from "react";
import { dispatch, CLOSE_MODAL, OPEN_MODAL, UPDATE_MODAL } from "./Util";

/**
    import {modal} from "components/HeadlessModal";
    modal.error({
        title: "Are you sure?",
        children: <div>This is the text</div>,
        onConfirm: () => {
            console.log("OK");
            modal.dismiss();
        },
        // OR
        buttons: ({disabled}) => (
            <button type="button" onClick={modal.dismiss} disabled={disabled}>Bork</button>
        ),
    });

    // custom modal

    import React, { Fragment } from "react";
    import { Dialog } from "@headlessui/react";
    import ModalRoot from "components/HeadlessModal/ModalRoot";

    export default function Modal(props) {
        return (
            <ModalRoot>
                {(modal) => (
                    <Fragment>
                        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900"
                                >
                                    {modal.title}
                                </Dialog.Title>
                                <div className="mt-2">{modal.children}</div>
                            </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                            {modal.buttons instanceof Array ? modal.buttons : ""}
                            {modal.buttons instanceof Function
                                ? modal.buttons(modal)
                                : ""}
                        </div>
                    </Fragment>
                )}
            </ModalRoot>
        );
    }

*/

const createDefaultButtonSet = (props) => {
    let useProps = { ...props };
    if (
        !props.hasOwnProperty("buttons") &&
        (!props.variant ||
            props.variant === "default" ||
            props.variant === "wide")
    ) {
        useProps.buttons = ({ onConfirm, onCancel, disabled }) => (
            <Fragment>
                <button type="button" onClick={onConfirm} disabled={disabled}>
                    Okay
                </button>
                <button type="button" onClick={onCancel} disabled={disabled}>
                    Cancel
                </button>
            </Fragment>
        );
        useProps.didProvideButtons = false;
    } else if (
        !props.hasOwnProperty("buttons") &&
        (!props.variant ||
            props.variant === "default" ||
            props.variant === "success")
    ) {
        useProps.buttons = ({ onConfirm, disabled }) => (
            <button type="button" onClick={onConfirm} disabled={disabled}>
                Okay
            </button>
        );
        useProps.didProvideButtons = false;
    } else if (
        !props.hasOwnProperty("buttons") &&
        props.variant === "warning"
    ) {
        useProps.buttons = ({ onConfirm, onCancel, disabled }) => (
            <Fragment>
                <button type="button" onClick={onConfirm} disabled={disabled}>
                    Okay
                </button>
                <button type="button" onClick={onCancel} disabled={disabled}>
                    Cancel
                </button>
            </Fragment>
        );
        useProps.didProvideButtons = false;
    } else if (!props.hasOwnProperty("buttons") && props.variant === "error") {
        useProps.buttons = ({ onConfirm, disabled }) => (
            <button type="button" onClick={onConfirm} disabled={disabled}>
                Okay
            </button>
        );
        useProps.didProvideButtons = false;
    } else {
        useProps.didProvideButtons = true;
    }

    return useProps;
};

export function modal(props) {
    dispatch({
        type: OPEN_MODAL,
        payload: Object.assign(
            {},
            {
                variant: "default",
                disabled: false,
                didProvideButtons: true,
            },
            props
        ),
    });

    return null;
}

modal.error = (props) => {
    const useProps = createDefaultButtonSet(
        Object.assign({}, props, { variant: "error", disabled: false })
    );
    dispatch({ type: OPEN_MODAL, payload: useProps });

    return null;
};

modal.warning = (props) => {
    const useProps = createDefaultButtonSet(
        Object.assign({}, props, { variant: "warning", disabled: false })
    );
    dispatch({ type: OPEN_MODAL, payload: useProps });

    return null;
};

modal.success = (props) => {
    const useProps = createDefaultButtonSet(
        Object.assign({}, props, { variant: "success", disabled: false })
    );

    dispatch({ type: OPEN_MODAL, payload: useProps });
    return null;
};

modal.loading = (props) => {
    dispatch({
        type: OPEN_MODAL,
        payload: { variant: "loading", disabled: false, ...props },
    });
    return null;
};

modal.wide = (props) => {
    const useProps = createDefaultButtonSet(
        Object.assign({}, props, { variant: "wide", disabled: false })
    );

    dispatch({
        type: OPEN_MODAL,
        payload: useProps,
    });
    return null;
};

modal.dismiss = () => {
    dispatch({ type: CLOSE_MODAL });
    return null;
};

modal.update = (props) => {
    dispatch({ type: UPDATE_MODAL, payload: props });
    return null;
};
